import type { McpServer } from '@modelcontextprotocol/sdk/server/mcp.js';
import { listPublicCollectionsV1Api } from '@repo/sdk';

export function registerListCollections(server: McpServer): void {
  server.registerTool(
    'list_collections',
    {
      title: 'List public Cool Mate collections',
      description:
        'List all published Cool Mate collections. Returns id, slug, title and type for each.',
      inputSchema: {},
    },
    async () => {
      const { data } = await listPublicCollectionsV1Api();
      return {
        content: [{ type: 'text', text: JSON.stringify(data?.data ?? []) }],
      };
    },
  );
}
